import ExpandMoreIcon from '@mui/icons-material/ExpandMoreRounded';
import { Components, Theme } from '@mui/material/styles';

export const MuiSelect: Components<Theme>['MuiSelect'] = {
  defaultProps: {
    IconComponent: ExpandMoreIcon,
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const isSmall = ownerState.size === 'small';

      return {
        '& .MuiSvgIcon-root': {
          right: '13px',
          color: theme.palette.grey[500],
        },
        '& .MuiSelect-select': {
          ...(isSmall
            ? { paddingBlock: '6px !important' }
            : {
                padding: '10px !important',
                paddingRight: '36px !important',
              }),
          height: 'auto !important',
        },
      };
    },
  },
};
